module.exports = __webpack_public_path__ + "static/media/6.b501f58c.png";